import React from "react";
import AlumniLine from "@unibuddy/machop/Experimental/Icons/AlumniLine";
import AlumniFilled from "@unibuddy/machop/Experimental/Icons/AlumniFilled";
import {useTranslation} from "react-i18next";
import IconTab from "../../components/IconTab/IconTab";

export default function AlumniHeaderTab(props) {
    const {t} = useTranslation("common");

    return (
        <IconTab
            {...props}
            id="alumni"
            name={t("alumni", "Alumni")}
            onClick={props.onClick}
            to={props.to}
            icon={isActive => (isActive ? <AlumniFilled /> : <AlumniLine />)}
        />
    );
}
